module.exports = __webpack_public_path__ + "assets/images/magazine_d29c79288e70b26cfbed1ecc9efa7560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-1/magazine.png
// module id = 254
// module chunks = 0